<template>
  <donut-chart34-template
    :board-ids="[114, 234, 235, 236, 237]"
    :data-type="dataType"
    field-code="workplace-material"
    :graph-id="70"
    title="(원료·제조물 사업장) 관리 현황"
    unit="건"
    :orientation="orientation"
  />
</template>

<script>
/* eslint-disable brace-style */
import DonutChart34Template from "@/views/graph/DonutChart34Template.vue";

export default {
  name: 'DonutChart70',
  components: {DonutChart34Template},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
}
</script>

<style scoped>

</style>
